import PropTypes from 'prop-types'
import { FilterSection } from './filter-section'
import { withActiveSortParams } from '../../../../reducers'
import ProductSort, {
  getSortOptions,
  getActiveOption,
} from '../../../product-sort'

const SortSectionBase = ({ open, sortParams, setActiveSortParams }) => {
  const sortOptions = getSortOptions()
  const activeOption = getActiveOption(sortParams, sortOptions)

  return (
    <FilterSection
      title="Sort"
      open={open}
      collapsedContent={activeOption.label}
    >
      <ProductSort
        sortOptions={sortOptions}
        activeOption={activeOption}
        activeSortParams={sortParams}
        setActiveSortParams={setActiveSortParams}
      />
    </FilterSection>
  )
}

SortSectionBase.propTypes = {
  open: PropTypes.bool.isRequired,
  sortParams: PropTypes.object.isRequired,
  setActiveSortParams: PropTypes.func.isRequired,
}

export const SortSection = withActiveSortParams()(SortSectionBase)
